// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-sequence-number[data-v-80002eec]{font-weight:400}.delivery-when[data-v-80002eec]{display:flex;column-gap:.5em}", ""]);
// Exports
module.exports = exports;
